import React, { useEffect, useState } from "react";
import FiltersPagination from "../../components/elements/FiltersPagination";
import DataTableElement from "../../components/elements/DataTableElement";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";
import { Columns } from "./Columns";
import { iaElementsResource } from "../../helpers/configRoutes/backend_helper";
import { useNavigate } from "react-router-dom";

const IAOperations = () => {
    const navigate = useNavigate()
    const [filters, setFilters] = useState({
        endDate: "",
        startDate: "",
        search: "",
        from: 0,
        to: 0,
        page: 1,
        truck: true,
    });

    const [load, setLoad] = useState({
        show: false,
        textLoad: "Loading AI services...",
    });

    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const [data, setData] = useState([]);

    const [modalConfirm, setModalConfirm] = useState({
        show: false,
        title: "Delete item",
        loading: false,
        textLoad: "Processing...",
        id: null,
    });

    const cols = Columns(navigate);

    const deleteIaElement = async () => {
        setModalConfirm((prev) => ({ ...prev, loading: true }));
        // Aquí integras tu delete real cuando esté listo:
        // const response = await iaElementsResource('del', {}, modalConfirm.id);
        // if (response.status) setFilters({ ...filters });
        setModalConfirm({
            show: false,
            title: "Delete item",
            loading: false,
            textLoad: "Processing...",
            id: null,
        });
    };

    useEffect(() => {
        const getData = async () => {
            setLoad((prev) => ({ ...prev, show: true }));

            const response = await iaElementsResource("get", { params: filters });

            if (response?.elements) setData(response.elements);
            if (response?.meta) setMeta(response.meta);

            setLoad((prev) => ({ ...prev, show: false }));
        };

        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters]);

    return (
        <div className="min-h-screen bg-cs-surface">
            <div className="px-4 md:px-6 py-6 max-w-auto mx-auto">
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                    <div>
                        <h1 className="text-2xl font-semibold text-cs-dark">
                            AI services
                        </h1>
                        <p className="text-sm text-cs-muted mt-1">
                            Monitor and manage AI-driven operations, prompts and automation logs.
                        </p>
                    </div>

                    <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
                        Total records:{" "}
                        <span className="font-semibold text-cs-dark">
                            {meta?.total || data.length || 0}
                        </span>
                    </div>
                </div>

                {/* Table + Pagination */}
                <div
                    className="
            bg-cs-bg border border-cs-border rounded-2xl
            shadow-sm px-2 py-2
          "
                >
                    <FiltersPagination
                        showFilters={false}
                        filters={filters}
                        setFilters={setFilters}
                        meta={meta}
                    >
                        <DataTableElement
                            columns={cols}
                            items={data}
                            tableLoad={load}
                        />
                    </FiltersPagination>
                </div>

                {/* Delete modal */}
                <ConfirmDeleteModal
                    modal={modalConfirm}
                    setModal={setModalConfirm}
                    action={deleteIaElement}
                />
            </div>
        </div>
    );
};

export default IAOperations;
